import React, { useEffect, useState } from 'react'
import './Movieedit.css'
import GetFormattedDate from './getFormattedDate'
import ListPersons from './ListPersons'
import './checkbox.css'
import Personinputmodel from './Personinputmode'
import Persongenre from './Persongenre'
import PersongenreTe from './PersongenerTe'
import { DefinedPermissions } from '../Constants/Permissions'
import { Auth } from 'aws-amplify'
import GetUserPermissions from '../../Services/Queries/GetUserPermissions'

export default function Persongrid() {
  const [personsLIst, setpersonsLIst] = useState([])
  const [editValue, setEditValue] = useState('')
  const [editFieldName, setEditFieldName] = useState('')
  const [pkValue, setPkValue] = useState('')
  const [checkedArray, setCheckedArray] = useState([])
  const [okButtonDisabled, setOkButtonDisable] = useState(false)
  const [arraySplit, setArraySplit] = useState('')
  const [genreFields, setGenreFields] = useState(Persongenre())
  const [genreFieldsTe, setGenreFieldsTe] = useState(PersongenreTe())
  const [genre, setGenre] = useState('')
  const [isPopSelected, setPop] = useState(false)
  const [genreTeOrEn, setGenreTeOrEn] = useState()
  const [ApproveOptionPermission, setApproveOptionPermission] = useState(false)
  const [EDitOptionPermission, setEDitOptionPermission] = useState(false)
  const [DeleteOptionPermission, setDeleteOptionPermission] = useState(false)
  const [BulkActionPermission, setBulkActionPermission] = useState(false)
  const sendPersonsData = data => {
    setpersonsLIst(data)
  }

  const sendCheckedArray = data => {
    setCheckedArray(data)
  }

  const handleCancelClick = () => {
    const genereField =
      genreTeOrEn === 'genres_En' ? [...genreFields] : [...genreFieldsTe]
    genereField.forEach((item, index) => {
      genereField[index].selected = false
    })
    setPop(!isPopSelected)
  }

  const genreEditFunction = (item, name) => {
    setGenreTeOrEn(name)
    const arrayGenreIndex = []
    const genereField =
      name === 'genres_En' ? [...genreFields] : [...genreFieldsTe]
    const splitedArrayvalues = item[name] && item[name].split(',')
    splitedArrayvalues.forEach(j =>
      genereField.forEach((e, index1) => {
        if (e.value === j) {
          arrayGenreIndex.push(index1)
        }
      }),
    )
    arrayGenreIndex.forEach(e => {
      genereField[e].selected = true
    })
    if (arrayGenreIndex.length === 0) {
      genereField.forEach((item, index) => {
        genereField[index].selected = false
      })
    }

    setGenre(genereField)
  }

  const editFunction = (item, name) => {
    setPop(!isPopSelected)
    setPkValue(item.PK)
    setEditFieldName(name)
    if (name === 'dateOfBirth') {
      setEditValue(GetFormattedDate(item[name]))
    } else if (name === 'roles') {
      setEditValue(item[name].toString())
    } else if (name === 'occupation_En') {
      const splitedArrayvalues =
        item[name] &&
        item[name].split(',').map(e => ({ label: e, value: e }))
      setArraySplit(splitedArrayvalues)
    } else if (name === 'occupation_Te') {
      const splitedArrayvalues =
        item[name] &&
        item[name].split(',').map(e => ({ label: e, value: e }))
      setArraySplit(splitedArrayvalues)
    } else if (name === 'genres_En') {
      genreEditFunction(item, name)
    } else if (name === 'genres_Te') {
      genreEditFunction(item, name)
    } else {
      setEditValue(item[name])
    }
  }

  const onAddingItem = (_e, _item, index) => {
    const data = [...personsLIst]
    data[index].isAdded = !data[index].isAdded
    const checkedData = data.map(e => {
      if (e.isAdded === true) {
        return e
      }

      return undefined
    })
    const checkedFilteredData = checkedData.filter(e => e !== undefined)
    setCheckedArray(checkedFilteredData)
    setpersonsLIst(data)
  }

  const genresFunction = index => {
    const data = [...genre]
    data[index].selected = !data[index].selected
    const checkedData = data.map(e => {
      if (e.selected === true) {
        return e
      }

      return undefined
    })
    const checkedFilteredData = checkedData.filter(e => e !== undefined)(
      editFieldName === 'genres_En' ? setGenreFields : setGenreFieldsTe,
    )(data)
    setGenre(data)
    const editedvalue = checkedFilteredData.map(a => a.value)
    setEditValue(editedvalue.toString())
    setOkButtonDisable(true)
  }

  const changeValue = (event, val, index) => {
    if (editFieldName === 'genres_En') {
      genresFunction(index, 'genres_En')
    } else if (editFieldName === 'genres_Te') {
      genresFunction(index, 'genres_Te')
    } else if (editFieldName === 'occupation_En') {
      setEditValue(event)
      setOkButtonDisable(true)
    } else if (editFieldName === 'occupation_Te') {
      setEditValue(event)
      setOkButtonDisable(true)
    } else {
      setEditValue(event.target.value)
      setOkButtonDisable(true)
    }
  }

  const val = ['TRUE', 'FALSE']
  const valueActive = val.map((e, index) => (
    <div key={index} className='restrictionage1'>
      <div
        onClick={() => {
          setEditValue(e)
          setOkButtonDisable(true)
        }}
        className={`restrictionage ${editValue === e ? 'restrictionage2' : ''}`}
      >
        {e}
      </div>
    </div>
  ))

  const inputmodel = Personinputmodel(
    [editFieldName, editValue, valueActive, genre],
    changeValue,
  )

  const sendOkButtonDisable = data => {
    setOkButtonDisable(data)
  }

  const sendPop = data => {
    setPop(data)
  }

  useEffect(() => {
    const getPermissions = async () => {
      const permissionInput = {
        mobileNumber: Auth.user.attributes.phone_number,
      }
      const userPermissions = await GetUserPermissions(permissionInput)
      const permissions = []
      const permissionsArr = []
      if (userPermissions && userPermissions.userRolesAndPermissions) {
        userPermissions.userRolesAndPermissions.map(item => {
          permissions.push(...item.permissions)
          return item
        })
        permissions.map(permission => {
          permissionsArr.push(permission.name)
          return permission
        })
      }

      const ApproveOptionPermission = permissionsArr.includes(
        DefinedPermissions.DisplayApprovePersonOption,
      )
      const EDitOptionPermission = permissionsArr.includes(
        DefinedPermissions.EditPeronPermission,
      )
      const DeleteOptionPermission = permissionsArr.includes(
        DefinedPermissions.DeletePersonPermission,
      )
      const BulkActionPermission = permissionsArr.includes(
        DefinedPermissions.AllPersonsBulkAction,
      )

      setApproveOptionPermission(ApproveOptionPermission)
      setEDitOptionPermission(EDitOptionPermission)
      setDeleteOptionPermission(DeleteOptionPermission)
      setBulkActionPermission(BulkActionPermission)
    }

    getPermissions()
  }, [])

  useEffect(() => {
    setEditValue(arraySplit)
  }, [arraySplit])
  return (
    <div>
      <ListPersons
        inputmodel={inputmodel}
        onAddingItem={onAddingItem}
        editFunction={editFunction}
        sendOkButtonDisable={sendOkButtonDisable}
        sendPersonsData={sendPersonsData}
        sendCheckedArray={sendCheckedArray}
        handleCancelClick={handleCancelClick}
        okButtonDisabled={okButtonDisabled}
        personsLIst={personsLIst}
        sendPop={sendPop}
        isPopSelected={isPopSelected}
        setpersonsLIst={setpersonsLIst}
        editFieldName={editFieldName}
        checkedArray={checkedArray}
        editValue={editValue}
        pkValue={pkValue}
        ApproveOptionPermission={ApproveOptionPermission}
        EDitOptionPermission={EDitOptionPermission}
        DeleteOptionPermission={DeleteOptionPermission}
        BulkActionPermission={BulkActionPermission}
      />
    </div>
  )
}
